
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Home = () => {
  const { t } = useTranslation();

  const stats = [
    { number: '15+', label: t('yearsExperience') },
    { number: '5000+', label: t('successfulPlacements') },
    { number: '200+', label: t('partnerCompanies') },
    { number: '5', label: t('countries') },
  ];

  const services = [
    {
      icon: 'ri-hotel-line',
      title: t('hospitalityTitle'),
      description: t('hospitalityDesc'),
    },
    {
      icon: 'ri-building-line',
      title: t('constructionTitle'),
      description: t('constructionDesc'),
    },
    {
      icon: 'ri-heart-pulse-line',
      title: t('medicalTitle'),
      description: t('medicalDesc'),
    },
    {
      icon: 'ri-computer-line',
      title: t('technicalTitle'),
      description: t('technicalDesc'),
    },
  ];

  const clientLogos = [
    {
      name: 'Care Health',
      logo: 'https://bichatravels.com/assets/images/healthcare_client_log/care_health.jpeg'
    },
    {
      name: 'Doha Care Services',
      logo: 'https://bichatravels.com/assets/images/healthcare_client_log/doha.jpeg'
    },
    {
      name: 'GMC',
      logo: 'https://bichatravels.com/assets/images/healthcare_client_log/gmc.jpeg'
    },
    {
      name: 'Ideal Plaza Medical Center',
      logo: 'https://bichatravels.com/assets/images/healthcare_client_log/idea.jpeg'
    },
    {
      name: 'Baumat',
      logo: 'https://bichatravels.com/assets/images/gcc/baumat.jpeg'
    },
    {
      name: 'CocaCola',
      logo: 'https://bichatravels.com/assets/images/gcc/coacola.jpeg'
    },
    {
      name: 'Dawood',
      logo: 'https://bichatravels.com/assets/images/gcc/dawood.jpeg'
    },
    {
      name: 'General Trading',
      logo: 'https://bichatravels.com/assets/images/gcc/general_trading.jpeg'
    },
    {
      name: 'Inno',
      logo: 'https://bichatravels.com/assets/images/gcc/inno.jpeg'
    },
    {
      name: 'Kaprel',
      logo: 'https://bichatravels.com/assets/images/gcc/kaprel.jpeg'
    },
    {
      name: 'Kudu',
      logo: 'https://bichatravels.com/assets/images/gcc/kudu.jpeg'
    },
    {
      name: 'Life',
      logo: 'https://bichatravels.com/assets/images/gcc/life.jpeg'
    },
    {
      name: 'Modern Bus',
      logo: 'https://bichatravels.com/assets/images/gcc/modern_bus.jpeg'
    },
    {
      name: 'Nabati',
      logo: 'https://bichatravels.com/assets/images/gcc/nabati.jpeg'
    },
    {
      name: 'Nadec',
      logo: 'https://bichatravels.com/assets/images/gcc/nadec.jpeg'
    },
    {
      name: 'Paris',
      logo: 'https://bichatravels.com/assets/images/gcc/paris.jpeg'
    },
    {
      name: 'Pizza',
      logo: 'https://bichatravels.com/assets/images/gcc/pizza.jpeg'
    },
    {
      name: 'Qaid',
      logo: 'https://bichatravels.com/assets/images/gcc/qaid.jpeg'
    },
    {
      name: 'Saif',
      logo: 'https://bichatravels.com/assets/images/gcc/saif.jpeg'
    },
    {
      name: 'Savola',
      logo: 'https://bichatravels.com/assets/images/gcc/savola.jpeg'
    },
    {
      name: 'Shaker',
      logo: 'https://bichatravels.com/assets/images/gcc/shaker.jpeg'
    },
    {
      name: 'Sunbula',
      logo: 'https://bichatravels.com/assets/images/gcc/sunbula.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Modern%20professional%20business%20office%20building%20with%20glass%20facade%20in%20Middle%20East%20GCC%20countries%2C%20clean%20architecture%2C%20blue%20sky%2C%20corporate%20environment%2C%20professional%20atmosphere%2C%20high%20quality%2C%20business%20district&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              {t('heroTitle')}
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
              {t('heroSubtitle')}
            </p>
            <p className="text-lg mb-10 text-gray-300 max-w-3xl mx-auto leading-relaxed">
              {t('heroDescription')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
                {t('getStarted')}
              </button>
              <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
                {t('learnMore')}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* License Information */}
      <section className="py-12 bg-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
            <div className="flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-blue-600 text-3xl w-8 h-8 flex items-center justify-center mr-3"></i>
              <h3 className="text-xl font-semibold text-gray-900">Government Approved Agency</h3>
            </div>
            <p className="text-gray-700 mb-2">
              <strong>Licence No.:</strong> B-1701/KER/PER/1000+/5/9853/2021
            </p>
            <p className="text-gray-600 text-sm">
              Approved by Government of India, Ministry of External Affairs
            </p>
          </div>
        </div>
      </section>

      {/* Client Logos Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Trusted Partners</h2>
            <p className="text-xl text-gray-600">We work with leading companies across the GCC region</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clientLogos.map((client, index) => (
              <div key={index} className="flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-12 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-200"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-gray-600 text-lg">{t('trustedBy')}</p>
            <h2 className="text-3xl font-bold text-gray-900 mt-2">{t('gccEmployers')}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-blue-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('certifiedAgency')}</h3>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-blue-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('qualityAssured')}</h3>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-blue-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">GCC Specialists</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                {t('aboutTitle')}
              </h2>
              <p className="text-xl text-gray-600 mb-6">
                {t('aboutSubtitle')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-8">
                {t('aboutDescription')}
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('ourMission')}</h3>
                  <p className="text-gray-600 text-sm">{t('missionText')}</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('ourVision')}</h3>
                  <p className="text-gray-600 text-sm">{t('visionText')}</p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20business%20team%20meeting%20in%20modern%20office%2C%20diverse%20group%20of%20people%20discussing%20recruitment%20strategies%2C%20clean%20modern%20office%20environment%2C%20natural%20lighting%2C%20professional%20atmosphere%2C%20business%20consultation&width=600&height=400&seq=about-img&orientation=landscape"
                alt="About Bicha Travels"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('servicesTitle')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('servicesSubtitle')}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-200">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-blue-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Start Your GCC Career Journey?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Connect with our experienced recruitment team and discover exciting opportunities across Qatar, Oman, Kuwait, Saudi Arabia, and the wider GCC region.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
              {t('contact')}
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
              View Services
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;